import React, { useEffect } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import useFetch from '../../../../hooks/useFetch.js';
import { getV2PlayerDetails } from '../../../../../api/index.js';
import { useParams } from 'react-router-dom';
import PlayerDTO from '../../../../DTO/PlayerDTO.js';
import FormPlayer from '../create/FormPlayer.js';

const EditPlayer = () => {

    const { id } = useParams()

    const { data, isLoading, error, fetchData } = useFetch(getV2PlayerDetails, [id]);

    useEffect(() => {
        if(!id)
            return
        fetchData()

    }, [id])

    useEffect(() => {

    }, [data])

    useEffect(() => {

        console.log("Error", error)

    }, [error])


    if(isLoading)
        return <CircularProgress/>
    
    if(!data)
        return <Typography sx={{m : 3}}>Aucun joueur trouvé</Typography>

    return <FormPlayer player={new PlayerDTO(data)} />

}

export default EditPlayer